import React, { useState } from 'react';
import styled from 'styled-components';
import { AppleIcon, AuthArrow, FacebookIcon, GoogleIcon, LoginImg, LoginMailIcon, PasswordIcon, PhoneIcon, ShowPassIcon, WebLogo, WebLogoMain } from '../utils/Images';
import { Switch } from 'antd';
import { useNavigate } from 'react-router-dom';
import ForgotPasswordModal from './ForgotPasswordModal';
import { loginuser } from '../collection/ApiCollection';
import { toast } from 'react-toastify';
import * as Yup from 'yup'; // ✅ Import Yup
import { Field, Form, Formik } from 'formik';
import { authlogin } from '../store/Authentication';
import { useDispatch } from 'react-redux';
import { cousntryCodesArr } from '../utils/constants';

const Login = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [openorgotPasModal, setOpenForgotPasModal] = useState(false)
    const [countryCode, setCountryCode] = useState("+1");
    const [passwordType, setPasswordType] = useState("password")
    const [inputValue, setInputValue] = useState("");
    const [loader, setLoader] = useState(false)
    const handleInputCheck = (e) => {
        const value = e.target.value;
        setInputValue(value);
    };
    // const validationSchema = Yup.object({
    //     email: Yup.string().required("Password is required").min(6, "Password must be at least 6 characters"),
    //     password: Yup.string().required("Password is required").min(6, "Password must be at least 6 characters"),
    // });
    const isPhoneNumber = (value) => {
        return /^\d+$/.test(value) && value.length > 6; // Adjust length check based on typical phone numbers
    };
    const checkType = isPhoneNumber(inputValue);

    const handleOpenForgotPasModal = () => {
        setOpenForgotPasModal(true)
    }
    const handleCancelForgotPasModal = () => {
        setOpenForgotPasModal(false)
    }

    const onChange = (checked) => {
        console.log(`switch to ${checked}`);
    };

    const initialValues = {
        email: "",
        password: ""
    }

    const onSubmit = async (value) => {
        if (!value?.password?.length > 0) {
            toast.error('Please enter valid password')
            return
        }
        setLoader(true)
        let reqForEmail = {
            email: inputValue,
            password: value?.password
        }
        let reqForNum = {
            phoneNumber: inputValue,
            countryCode: countryCode,
            password: value?.password
        }
        try {
            let res = await loginuser(checkType ? reqForNum : reqForEmail);
            console.log(res)
            if (res.status === 200) {
                toast.success(res?.data?.message)
                dispatch(authlogin(res?.data?.data))
                setLoader(false)
            } else {
                toast.error(res?.data?.response?.data?.message)
                setLoader(false)
            }
        } catch (error) {
            console.log(error)
            toast.error(error?.response?.data?.errors?.[0]?.msg || error?.response?.data?.message || error?.message || "Something went wrong")
            setLoader(false)
        }
    }

    const handlePasswordType = (value) => {
        console.log(value, "passwordType00")
        if (value === "password") {
            setPasswordType("text")
        } else {
            setPasswordType("password")
        }
    }

    return (
        <LoginWrapper>
            {openorgotPasModal &&
                <ForgotPasswordModal
                    openorgotPasModal={openorgotPasModal}
                    handleCancelForgotPasModal={handleCancelForgotPasModal}
                />
            }
            <div className='left-side'>
                <img src={WebLogoMain} alt="" width={80} height={68} className='webLogo' />
                <div className='inner-div'>
                    <div className='main-content'>
                        <h1>Welcome to Sophie <br />Sign into your account</h1>
                        <Formik initialValues={initialValues} onSubmit={onSubmit} >
                            <Form>
                                <div className='input-div'>
                                    {/* <div>
                                        <img src={LoginMailIcon} alt="" className='mail-icon' />
                                        <Field type='text' name='email' placeholder='Email or Phone number' />
                                    </div>*/}
                                    <div style={{ border: "none", padding: "0px" }}>
                                        {isPhoneNumber(inputValue) && (
                                            <select
                                                value={countryCode}
                                                onChange={(e) => setCountryCode(e.target.value)}
                                                className='country-code'
                                            >
                                                {cousntryCodesArr?.map((val) => {
                                                    return (
                                                        <option value={val?.code}>
                                                            {val?.code} {val?.name}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        )}
                                        <div style={{ display: "flex", alignItems: "center", marginTop: "0px" }}>
                                            <input
                                                type={isPhoneNumber(inputValue) ? "text" : "email"}
                                                required
                                                value={inputValue}
                                                onChange={handleInputCheck}
                                                placeholder="Email or Phone number"
                                            />
                                            <img src={isPhoneNumber(inputValue) ? PhoneIcon : LoginMailIcon} alt="" className='mail-icon' />
                                        </div>
                                    </div>
                                    <div>
                                        <img src={PasswordIcon} alt="" className='mail-icon' />
                                        <Field type={passwordType} name='password' placeholder='Your password' />
                                        <img src={ShowPassIcon} alt="" className='eye-icon' onClick={() => handlePasswordType(passwordType)} style={{ cursor: "pointer" }} />
                                    </div>
                                </div>
                                <div className='forget-pas-div'>
                                    <p className='for-flex'><Switch defaultChecked onChange={onChange} />Remember Me</p>
                                    <p style={{ cursor: "pointer" }} onClick={() => handleOpenForgotPasModal()}>Forgot Password?</p>
                                </div>
                                <div className='signin-method'>
                                    <button type='submit'>{loader ? "Loading..." : <>SIGN IN <img src={AuthArrow} alt="" /></>}</button>
                                </div>
                            </Form>
                        </Formik>
                        <p className='or-div'>OR</p>
                        <div className='log-in-with'>
                            <p><img src={GoogleIcon} alt="" />Login with Google</p>
                            <p><img src={FacebookIcon} alt="" />Login with Facebook</p>
                            <p><img src={AppleIcon} alt="" />Login with Apple</p>
                        </div>
                        <p className='dont-have-account' onClick={() => navigate("/onboarding")}>Don’t have an account?  <span>Sign up</span></p>
                    </div>
                </div>
            </div>
            <div className='right-side'>
                <img src={LoginImg} alt="" />
            </div>
        </LoginWrapper>
    )
}

export default Login

const LoginWrapper = styled.div`
    display:flex;
    height:100%;
    .left-side{
        width:41%;
        position:relative;
        padding-bottom:29px;
        height:100%;

        @media (max-width: 1050px){
            width:100%;
        }

        .webLogo{
            position:absolute;
            left:71px;
            top:29px;
        }
        .inner-div{
            width:65%;
            margin:auto;
            margin-top:154px;

            @media (max-width: 750px){
                width:85%;
            }

            .main-content{
                h1{
                    font-weight:700;
                    font-size:21px;
                    text-align:center;
                }
                .input-div{
                    div{
                        margin:auto;
                        margin-top:31px;
                        border:1px solid #E4DFDF;
                        border-radius:12px;
                        height:70px;
                        display:flex;
                        align-items:center;
                        gap:15px;
                        position:relative;
                        max-width:383px;
                        width:100%;

                        .country-code{
                            height:70px;
                            border-radius:12px;
                            border:1px solid #E4DFDF;
                        }

                        .mail-icon{
                            width:27px;
                            height:27px;
                            position:absolute;
                            z-index:9;
                            left:20px;
                        }
                        .eye-icon{
                            width:29px;
                            height:30px;
                            position:absolute;
                            z-index:9;
                            right:20px;
                        }
                        input{
                            font-size:14px;
                            font-weight:400;
                            border:none;
                            height:100%;
                            position:relative;
                            padding:0px 60px;
                            border-radius:12px;
                            width:100%;

                            &:focus{
                                outline:none;
                            }
                        }
                    }
                }
                .forget-pas-div{
                    display:flex;
                    align-items:center;
                    justify-content:space-between;
                    margin-top:34px;
                    margin-bottom:25px;

                    @media (max-width: 450px){
                        display:block;
                    }

                    .for-flex{
                        display:flex;
                        align-items:center;
                        gap:5px;

                    }
                    p{
                        font-size:14px;
                        font-weight:400;

                        @media (max-width: 450px){
                            text-align:right;
                            margin-top:10px;
                        }
                    }
                }
                .signin-method{
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    button{
                        color:#fff;
                        font-size:16px;
                        font-weight:400;
                        background:#0DA982;
                        height:48px;
                        padding:0px 30px;
                        position:relative;
                        border:none;
                        border-radius:15px;
                        display:flex;
                        align-items:center;
                        max-width:225px;
                        width:100%;
                        justify-content:center;

                        img{
                            position:absolute;
                            width:24px;
                            height:24px;
                            right:10px;
                        }
                    }
                }
                .or-div{
                    font-size:16px;
                    font-weight:500;
                    color:#9D9898;
                    margin-top:15px;
                    margin-bottom:25px;
                    text-align:center;
                }
                .log-in-with{
                    display:flex;
                    flex-direction:column;
                    gap:17px;
                    align-items:center;

                    p{
                        font-size:16px;
                        font-weight:400;
                        box-shadow: 15px 0px 30px 0px #D3D4E240;
                        border-radius:12px;
                        height:60px;
                        max-width:283.64px;
                        width:100%;
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        gap:20px;

                        img{
                            width:28px;
                            height:28px;
                        }
                    }
                }
                .dont-have-account{
                    font-size:15px;
                    font-size:400;
                    margin-top:29px;
                    cursor:pointer;
                    text-align:center;

                    span{
                        color:#5669ff;
                    }
                }


            }
        }

    }
    .right-side{
        width:59%;
        display:unset;

        @media (max-width: 1050px){
            display:none;
        }
        
        img{
            width:100%;
            height:950px;
        }
    }


`;